<template>
  <div class="rightContent">
    <trainMenu ref="trainmenu" :trainCategories='trainCategories'
    @category-path-updated = 'onTrainCategoryChoose' :isModal="isModal"></trainMenu>
    <component ref="traincontent" :is="currentView" :trainCategories='trainCategories'
      :trainList = 'currentTrainCategory ? sortGame(currentTrainCategory.games) : []'>
    </component>
  </div>
</template>

<script>
  import trainMenu from '../components/common/trainMenu.vue'
  import digEvalContent from '../components/service/evaluation/digEvalContent.vue'
  import Vue from 'vue'
  import bz_utils from '../components/common/tree/utils/index.js'

  /**
   * 创建分类的树状结构
  */
  let trainCats = bz_utils.buildEvalCategoryTree();

  export default {
    name: 'evaluation',
    components: {
      trainMenu,
      digEvalContent,
    },
    data(){
      return{
        trainCategories: trainCats,
        currentTrainCategory: null,
        trains: null,
        count:0,
        isModal:false,
      }
    },
    computed: {
      currentView: function(){
        return 'digEvalContent';
      },
    },
    methods : {
      onTrainCategoryChoose(categoryPath){
        var self = this;
        let cat = categoryPath.slice(-1)[0];
        let eval2;
        this.currentTrainCategory = cat;
        if (this.trains === null){
          Vue.http({
            method: 'GET',
            url:'/api/Evaluation/getScales',
            params: {}
          })
          .then((res)=>{
            eval2 = res.data.data;
            Vue.http({
              method: 'GET',
              url: '/api/Evaluation/assess_scales',
            }).then(resp=>{
              let flat_games =resp.data.data;
              flat_games = eval2.concat(flat_games);
              self.trainCategories.resetGames(flat_games,true);
              self.trains = flat_games;
              self.count ++;
            })
          });
        }
      },
      sortGame: function(games){
        //2.0和1.0量表字段大小写不一样
        var arr = [];
        if(this.count > 0){
          this.trains.forEach((item)=>{
            if(item.id){
              item['ID'] = item.id; 
            }
            games.forEach((game)=>{
              if(game.id){
                game['ID'] = game.id;
              }
              if(game.ID == item.ID){
                arr.push(game);
              }
            })
          })
        }
        return arr;
      },
      parentFun:function(evtValue){//侦听evalMenu子页面的事件
        this.$refs.content.childCallTwo(evtValue);
      }
    }
  }
</script>
<style lang="stylus">
  @import "../assets/css/app.styl"
  @import "../assets/css/variable.styl"

  .rightContent
    position absolute
    left 231px
    top $top-height
    right 0
    height calc(100% - 101px)
</style>



// WEBPACK FOOTER //
// evaluation.vue?4b9ba0ae